import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'antd';
import { LoadingOutlined, EyeOutlined } from '@ant-design/icons';
import './styles.css';

const { Column } = Table;

const UsersTableAdmin = ({ data, onUserReservationsById }) => {
    return (
        <Table className="usersTableAdminCont" dataSource={data} rowKey={record => (record.uid)} size="small" pagination={true}>
            <Column title="Apellido" dataIndex="lastName" key="lastName" sorter={(a, b) => a.lastName.localeCompare(b.lastName) } align="center" />
            <Column title="Nombre" dataIndex="firstName" key="firstName" sorter={(a, b) => a.firstName.localeCompare(b.firstName) } align="center" />
            <Column title="Email" dataIndex="email" key="email" sorter={(a, b) => a.email.localeCompare(b.email) } align="center" />
            <Column title="Teléfono" dataIndex="phone" key="phone" align="center" />
            <Column title="" dataIndex="isLoading" key="isLoading" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true}>
                                    <LoadingOutlined />
                                </Button>
                                :
                                <Button type="primary" onClick={() => onUserReservationsById(record)}>
                                    <EyeOutlined /> Reservas
                                </Button>
                        }
                    </span>
                )}
            />
        </Table>
    );
};

UsersTableAdmin.propTypes = {
    data: PropTypes.array,
    onUserReservationsById: PropTypes.func,
};

export default UsersTableAdmin;